<div class="PGNotes">
    <button type="button" class="btn btn-light PGNotes-Trigger" [class.active]="isOpen" [disabled]="isLoading || hasError || normalizedChannelId == null" (click)="toggleOpen()" [title]="displayTitle">
        <span>Note</span>
        <i class="fa-regular fa-lg fa-sticky-note ms-2"></i>
        @if (notesCountLabel; as count) {
            <span class="badge bg-danger m-0 p-1 position-absolute">{{ count }}</span>
        }
    </button>

    @if (isOpen) {
        <div class="PGNotes-Panel border bg-white shadow">
            <div class="PGNotes-Panel-Header border-bottom px-2 py-1 d-flex align-items-center justify-content-between gap-2">
                <div class="PGNotes-Panel-Title text-truncate">{{ displayTitle }}</div>
                @if (channel.status?.users; as users) {
                    <span ngbDropdown [autoClose]="'outside'" class="PGNotes-Users">
                        <button type="button" class="btn btn-sm btn-light" ngbDropdownToggle>
                            <i class="fa-regular fa-users"></i> {{ users.length }}
                        </button>
                        <div ngbDropdownMenu class="PGNotes-Users-Menu">
                            @for (user of users; track user) {
                                <div class="dropdown-item-text small">
                                    <app-pg-user-status [userId]="user"></app-pg-user-status>
                                </div>
                            }
                        </div>
                    </span>
                }
            </div>
            <div class="PGNotes-Panel-Body">
                @if (isLoading && channel.status == null) {
                    <app-pg-loading></app-pg-loading>
                }
                @if (hasError) {
                    <div class="p-3 text-muted small">Notes unavailable</div>
                }
                @if (!hasError) {
                    <app-pg-chat-channel
                        [showHeader]="false"
                        [ready]="channel.status != null"
                        [messages]="channel.status?.messages || []"
                        [typing]="getTyping()"
                        [resolveUserName]="resolveUserName"
                        [allowAttachments]="true"
                        [disabled]="isSaving || isLoading"
                        (sendMessage)="onSendMessage($event)"
                        (typingChange)="onTypingChange($event)"
                        (filesSelected)="onFilesSelected($event)">
                    </app-pg-chat-channel>
                }
            </div>
        </div>
    }
</div>
